import { action, extendObservable, computed } from 'mobx';

import messagingService from 'services/MessagingService/MessagingService';
import {
  GET_PERFORMER_TIPPING_SESSION,
  GET_PERFORMER_TIPPING_SESSION_ERROR,
  GET_TIPPING_INFO,
  SEND_TIP,
  SEND_TIP_ERROR,
  SEND_TIP_RESPONSE,
  SEND_TIP_RESPONSE_STATUS,
  SHOW_BUY_TOKENS_MODAL_TRIGGER,
  SHOW_UPGRADE_TO_GOLD_MODAL,
  TIPPING_INFO_ERROR,
  UPDATE_ANONYMOUS_TIPPING_HASH,
  UPDATE_BALANCE,
} from 'services/MessagingService/EventNames';
import TippingService from 'services/TippingService';
import tippingStoreInitialState from 'stores/TippingStoreInitialState';
import APIStates from 'enum/APIStates';


class TippingStore {
  constructor() {
    extendObservable(this, tippingStoreInitialState);
    this.messagingService = messagingService();
    this.messagingService.on(SEND_TIP_RESPONSE, this._handleTipResponse);
    this.messagingService.on(SEND_TIP_ERROR, this._handleTipError);
    this.messagingService.on(UPDATE_BALANCE, this._handleUpdateBalance);
    this.messagingService.on(GET_TIPPING_INFO, this._handleTippingInfo);
    this.messagingService.on(TIPPING_INFO_ERROR, this._handleTipingInfoError);
    this.messagingService.on(SEND_TIP_RESPONSE_STATUS, this._handleSendTipResponseStatus);
    this.messagingService.on(UPDATE_ANONYMOUS_TIPPING_HASH, this.setAnonymousTippingHash);
    this.messagingService.on(GET_PERFORMER_TIPPING_SESSION, this._handlePerformerSessionTippingInfo);
    this.messagingService.on(GET_PERFORMER_TIPPING_SESSION_ERROR, this._handlePerformerSessionTippingInfoError);
  }

  @action sendTip = (data) => {
    this.sendTipStatus = APIStates.PENDING;
    this.messagingService.emit(SEND_TIP, data);
  };

  @action getPerformerSessionTippingInfo = (user, tippingSession, shouldSetPerfomerMessage) => {
    this.performerSessionTippingInfoStatus = APIStates.PENDING;
    TippingService.getPerformerSessionTippingInfo(user, tippingSession, shouldSetPerfomerMessage);
  };

  @action getTippingInfo = (username, roomName, user, sessionId) => {
    if (window.navigator.onLine) {
      this.tippingInfoStatus = APIStates.PENDING;
      TippingService.getTippinginfo(username, roomName, user, sessionId);
    }
  };

  _handleTipResponse = (data) => {
    this.sendTipStatus = APIStates.LOADED;
    this.lastTippedAmount = data.amount;
  };

  _handleTipError = () => {
    this.sendTipResponseStatus = APIStates.ERROR;
    this.sendTipStatus = APIStates.ERROR;
  };

  _handleUpdateBalance = (balance) => {
    if (!isNaN(balance)) {
      this.tokenBalance = balance;
    }
  };

  @action _handleTippingInfo = (tippingInfo) => {
    this.tippingInfoStatus = APIStates.LOADED;
    this.tippingInfo = tippingInfo;
  };

  _handleTipingInfoError = () => {
    this.tippingInfoStatus = APIStates.ERROR;
  };

  _handleSendTipResponseStatus = (sendTipResponseStatus) => {
    this.setSendTipResponseStatus(sendTipResponseStatus);
  };

  @action _handlePerformerSessionTippingInfo = (info) => {
    this.performerSessionTippingInfo = info;
    this.performerTopTipper = info.toptipper;
    this.performerTopTipperAmount = info.tlamount;
  };

  @action _handlePerformerSessionTippingInfoError = () => {
    this.performerSessionTippingInfoError = APIStates.ERROR;
  };

  @action setLastTippedAmount = (amount) => {
    this.lastTippedAmount = amount;
  };

  @action setAnonymousTippingHash = (anonymousTippingHash) => {
    this.anonymousTippingHash = anonymousTippingHash && anonymousTippingHash.split('|')[1];
  };

  @action setSendTipResponseStatus = (sendTipResponseStatus) => {
    this.sendTipResponseStatus = sendTipResponseStatus;
  };

  @computed get isPerformerGoalVisible() {
    return this.tippingInfo.goal;
  }

  @computed get isLoadingBeatTheLeaderTip() {
    return this.sendTipResponseStatus === APIStates.PENDING;
  }

  @computed get getLastTippedAmount() {
    return this.lastTippedAmount;
  }

  @action resetTippingStoreState = () => {
    Object.keys(tippingStoreInitialState).forEach((item) => (this[item] = tippingStoreInitialState[item]));
  };

  @action showBuyTokensModal = () => {
    this.messagingService.emit(SHOW_BUY_TOKENS_MODAL_TRIGGER);
  };

  @action showUpgradeToGold = () => {
    this.messagingService.emit(SHOW_UPGRADE_TO_GOLD_MODAL);
  };
}

export default new TippingStore();
